const templates = {
  'Sales Rejection': (supplier) =>
`Dear ${supplier.firstname},

Thank you for your interest in joining VoiceArchive. We always welcome new applications and on-going dialogue with voice talents.

At the moment, our roster includes enough voice talents in your native language. This means that unfortunately, we are not onboarding new voice talents for your offering.

This might change soon. That is why we would like to keep your application for the next twelve months, to be able to onboard you if one of our future projects fits with your offering.
We will only store the information you have sent to us in your application (name, gender, contact info and native language)

If you don’t want us to store your applications, please email us an email and we will delete your application.


We’d like to thank you one more time for your application and interest and please reach out if you have any further questions. We’ll be happy to answer them.

All the best,
VoiceArchive’s Sourcing Team`,

  'Audio Quality Rejection': (supplier) =>
`Dear ${supplier.firstname},

Thank you for your interest in joining VoiceArchive. We always welcome new applications to expand our ever-growing list of exceptional voice talents.

Unfortunately, when reviewing your studio demo, attached in your application, our sound engineers have discovered some issues that prevent us from accepting your application and offering your audio directly to our clients.

These issues may include one or more of the following concerns, that have resulted in the declining of your application - high noise floor, loud room tone, harsh audio quality, room reflections, poor recording space, external noises, etc.

Here at VoiceArchive we aim to provide the best possible service to our clients. Consequently, we must always keep and ensure the highest audio quality recordings and for this reason, we cannot accept your application with us.

We would like to thank you for your interest, time and efforts spent on this application. Should you wish to have your application re-submitted, please only do so once improvements have been made.
In this case, we would kindly ask you to reach out to us on studio@voicearchive.com and send us a detailed description of improvements and changes that you have made, as well as photos showing before and after in your studio set-up. We would be happy to review your application then.

All the best,
VoiceArchive’s Sourcing Team`,

  'Request New Demos': (supplier) =>
`Dear ${supplier.firstname},

Thank you for your interest in joining VoiceArchive – it’s greatly appreciated. In order for us to fully assess your application, we would need further information/demo submissions from you.

Please go to Demo and delete your original studio and audition demos, and upload two new demos with these specifications:

- RAW demo in the following format: Mono, 48KHz, 24bit .wav

- Do not up sample 44.1KHz recordings to 48KHz

- Switch off any and all plugins within your DAW / recording program

- Do not de-noise or edit the recordings in any way at all

In this demo, please make sure to leave 5 seconds of silence at the end of the recording, with you standing quietly in the room, for us to evaluate the noise floor. (If you are unfamiliar with the term noise floor, it means for you to finish speaking the demo and quietly wait a few seconds before stopping the recording)

If you do not have a demo that fits these specs, please feel free to make a new recording with this studio demo script:

---

> Hi there!

> What you are listening to is my basic studio demo. The quality of the recording you are listening to right now, is what you can expect, if you choose me to do your next voice over job. Here in my studio I have taken the necessary precautions to ensure you high quality recordings for all your audio applications.

> Thanks for stopping by, and have a great day!

---

If we have not heard back from you within the next 14 days, we would unfortunately need to decline your application.

Thank you for your assistance on this. If you have any further questions or comments, please reach out. We’ll gladly assist you.

All the best,
VoiceArchive’s Sourcing Team`
}

export default templates
